










import { Component, Prop, Vue } from 'vue-property-decorator';
import { SelectItem } from '@/models/reports/select-item';

@Component
export default class ReportEntitySearchResultTemplate extends Vue {
    // Note(Seb): The following fields have to be called like this (that's what v-autocomplete uses by default)
    @Prop({ required: true }) private item!: SelectItem | null;
    @Prop({ required: true }) private searchText!: string;
}
